// extracted by mini-css-extract-plugin
module.exports = {"textArea":"WordListTextArea-textArea-8fff59b7c82ac324d86e6e9ffd125776"};